export default __webpack_public_path__ + "static/media/govt-civic.8dce17c3.jpg";